<template>
  <div class="bMembers">
    <div class="bMembers__container container pt-4">
      <div class="bMembers__header row">
        <div class="bMembers__header__h2 h2 col">會員管理</div>
      </div>
      <div class="bMembers__body row">
        <form class="col-12 col-md-6 col-lg-4 mb-3"
        v-for="(item, index) in members"
        :key="index"
        @submit.prevent="delete_member">
            <b-button
            v-b-toggle="`member${index}`"
            class="mb-1 w-100 d-flex flex-column align-items-center">
              <span>{{item.name}}</span>
            </b-button>
            <b-collapse :id="`member${index}`">
              <b-card class="p-0">
                <ul class="list-group">
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">會員ID</span>
                    <span>{{item.id}}</span>
                  </li>
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">會員姓名</span>
                    <span>{{item.name}}</span>
                  </li>
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">會員性別</span>
                    <span>{{convert_gender(item.gender)}}</span>
                  </li>
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">會員生日</span>
                    <span>{{item.birthday}}</span>
                  </li>
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">會員電話</span>
                    <a :href="`tel: ${item.tel}`">{{item.tel}}</a>
                  </li>
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">會員Email</span>
                    <a :href="`mailto: ${item.email}`">{{item.email}}</a>
                  </li>
                  <li class="list-group-item border-0
                  d-flex justify-content-end align-items-center">
                    <button class="btn btn-sm btn-danger"
                    @click.prevent="delete_member(item.id)">
                      刪除會員
                    </button>
                  </li>
                </ul>
              </b-card>
            </b-collapse>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      members: [],
    };
  },
  methods: {
    initialize_members() {
      this.$bus.$on('son_get_data', (data) => {
        this.members = JSON.parse(JSON.stringify(data.members));
      });
      this.$bus.$emit('son_call_data');
    },
    delete_member(id) {
      const dConfirm = window.confirm('確定要刪除嗎?');
      if (dConfirm) {
        this.$bus.$emit('delete_member', id);
      }
      this.initialize_members();
    },
    convert_gender(gender) {
      let str = '';
      switch (gender) {
        case 'male':
          str = '男';
          break;
        case 'female':
          str = '女';
          break;
        default:
          break;
      }
      return str;
    },
  },
  created() {
    this.initialize_members();
  },
};
</script>
